/**
 * Wiederherstellungscodes der Zwei-Faktor-Anmeldung (backend#9) als
 * Textdatei zum Herunterladen. Das Backend gibt sie genau einmal heraus.
 */

/** Inhalt der Datei. */
export function codesText(codes, konto, datum = new Date()) {
  return [
    "onDispatch – Wiederherstellungscodes für die Zwei-Faktor-Anmeldung",
    konto ? "Konto: " + konto : null,
    "Erstellt: " + datum.toLocaleDateString("de-DE"),
    "",
    "Jeder Code lässt sich genau einmal verwenden. Bewahre diese Datei sicher auf",
    "und gib sie nicht weiter.",
    "",
    ...codes,
    "",
  ]
    .filter((zeile) => zeile !== null)
    .join("\n");
}

/** Startet den Download im Browser. */
export function codesHerunterladen(codes, konto) {
  const blob = new Blob([codesText(codes, konto)], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "onDispatch-Wiederherstellungscodes.txt";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
